/* DEF Brand Colors — purple & gold from logo */
export const BRAND = {
  primary: "#5B2D8E",
  primaryDark: "#4A2574",
  primaryLight: "#F3EDF9",
  warm: "#F7F3ED",
  text: "#2C2C2C",
  textLight: "#666",
  gold: "#F2B630",
};
